export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/demandantes/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'DEMANDANTE'
        },
        regras: 'DESP-GERAIS-DEMAN-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/demandantes/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'DEMANDANTE'
        },
        regras: 'DESP-GERAIS-DEMAN-PAG-00'
    },
]